import { tns } from "tiny-slider/src/tiny-slider";

export default class MainSlider {
    static init() {
        const slider = document.getElementById('js-main-slider');
        const sliderControls = document.getElementById('js-main-slider-controls');
        const sliderList = document.getElementById('js-main-slider-list');

        const calculateSlideHeight = () => {
            // set height based on item with max-height
            let maxHeight = 0;
            for (let j = 0; j < slider.children.length; j++) {
                // if maxHeight based on height of max image bg
                let bg = slider.children[j].querySelector('.main-slider__bg');
                if (bg) {
                    if (bg.naturalHeight > maxHeight) {
                        maxHeight = bg.naturalHeight;
                    }
                }
                /*
                maxHeight based on height of max slider
                if (slider.children[j].clientHeight > maxHeight) {
                    maxHeight = slider.children[j].clientHeight;
                }
                 */
            }
            // zakomentovano - aby mohl být obrázek pro xsDesktop zmenšený
            // slider.style.height = `${maxHeight}px`;
        }

        if (slider) {
            if (window.matchMedia('(min-width:1280px)').matches) {
                calculateSlideHeight();
                setTimeout(()=> {
                    calculateSlideHeight();
                }, 500);
            }

            let tinySlider = tns({
                container: slider,
                mode: 'gallery',
                autoplayButtonOutput: false,
                controls: true,
                nav: true,
                autoplay: true,
                loop: true,
                lazyload: true,
                controlsContainer: sliderControls || false,
                navContainer: sliderList || false,
                items: 1,
                autoHeight: true,
                onInit: () => {
                    // set first three list items visible
                    for (let i = 0; i < sliderList.children.length; i++) {
                        sliderList.children[i].classList.add('visible');
                    }
                }
            });

            tinySlider.pause();

            setTimeout(() => {
                tinySlider.play();
            },5000);

            tinySlider.events.on('transitionStart', () => {
                let activeIndex = tinySlider.getInfo().displayIndex;
                activeIndex = activeIndex && activeIndex - 1

                // set visible items
                sliderList.children.forEach((child, i) => {
                    let diff = activeIndex === 0 || activeIndex === (sliderList.children.length - 1) ? 2 : 1

                    if (Math.abs(activeIndex - i) < (diff + 1) && !child.classList.contains('.visible')) {
                        child.classList.add('visible');
                    } else if (Math.abs(activeIndex - i) > 1) {
                        child.classList.remove('visible');
                    }
                })
            });
        }
    }
}
